import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Grid,
    styled,
    Typography,
    Fab,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import backgroundCircles from '../assets/BG-Join-Clients.png';
import axios from 'axios';
import JobComponent from '../components/Jobs/JobComponent';
import ViewJob from '../components/Jobs/ViewJob';
import Loading from '../components/Loading';
import AddIcon from '@mui/icons-material/Add';
import { grades } from '../utils/grades';
import { format, addDays, parse } from 'date-fns';
import { Helmet } from 'react-helmet';
const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: '1rem',
    margin: '4rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover, &:focus': {
        cursor: 'pointer',
        boxShadow:
            '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)',
    },
    [theme.breakpoints.down('sm')]: {
        margin: '2rem .3rem',
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '45rem',
        margin: '2rem auto',
    },
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const StyledBox = styled(Box)(({ theme }) => ({
    padding: '0px 14px 14px 14px',
    height: '80%',
    //textAlign: 'center', -- Allows the title to be centered
    position: 'relative',
}));

// const MobileTypography = styled(Typography)(({ theme }) => ({
//     [theme.breakpoints.down('sm')]: {
//         textAlign: 'center',
//     },
// }));

const SchoolJobs = () => {
    // let history = useHistory();
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    const setDate = Date.now();

    const dates = [
        format(addDays(setDate, 7), 'dd MMM yyyy'),
        format(addDays(setDate, 14), 'dd MMM yyyy'),
        format(addDays(setDate, 21), 'dd MMM yyyy'),
        format(addDays(setDate, 28), 'dd MMM yyyy'),
        format(addDays(setDate, 35), 'dd MMM yyyy'),
        format(addDays(setDate, 42), 'dd MMM yyyy'),
    ];

    const [state, setState] = useState({
        jobs: [],
        description: '',
        title: '',
        expiryDate: dates[3],
        typeOfJob: 'SecondarySchool',
        jobView: {},
    });

    const [redirectToHome, setRedirectToHome] = useState(false);
    const [loadingJobs, setLoadingJobs] = useState(false);
    const [newJob, setNewJob] = useState(false);

    useEffect(() => {
        async function getJobs() {
            setLoadingJobs(true);
            if (isAuthenticated === false) {
                setRedirectToHome(true);
            } else {
                const token = await getAccessTokenSilently();
                const getMyJobs = await axios.get(
                    `${process.env.REACT_APP_API_GATEWAY}/myjobs`,
                    {
                        timeout: 30000,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                );
                setState({ ...state, 'jobs': getMyJobs.data.Message.Data });
                //setJobs(getMyJobs.data.Message.Data);
                setLoadingJobs(false);
            }
        }
        getJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const viewJob = id => {
        setState({
            ...state,
            jobView: state.jobs.find(job => `${job.pk1}${job.sk1}` === id),
        });
        console.log(state.jobs.find(job => `${job.pk1}${job.sk1}` === id));
    };

    const closeJob = () => {
        setState({ ...state, jobView: {} });
    };
    const updateJobStatus = (pk1, sk1, gs1pk) => {
        let jobs = state.jobs;
        let filterJob = jobs.filter(item => {
            let jobItem = item;
            if (
                item.pk1 === pk1 &&
                item.sk1 === sk1 &&
                item['gs1-pk'] === gs1pk
            ) {
                jobItem.status = 'closed';
            }
            return jobItem;
        });
        setState({ ...state, jobs: filterJob });
        // console.log(filterJob);
    };
    const submitJob = async () => {
        const document = {
            'expiryDate': format(
                parse(state.expiryDate, 'dd MMM yyyy', new Date()),
                'yyyy-MM-dd'
            ),
            'jobSummary': state.description,
            'title': state.title,
            'typeOfJob': state.typeOfJob,
        };

        const token = await getAccessTokenSilently();
        const createJob = await axios.post('/addJob', document, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (createJob.data.Message.Success === true) {
            setNewJob(false);
            //setDescription('');
            //setTitle('');

            setState({
                ...state,
                'description': '',
                'title': '',
                'jobs': [createJob.data.Message.Data, ...state.jobs],
            });
            //const subList = jobs;
            //console.log('jobData', createJob.data.Message.Data);
            //subList.push(createJob.data.Message.Data);
            //setJobs(createJob.data.Message.Data);
        } else {
            console.log(JSON.stringify(createJob));
        }
    };
    return (
        <>
            <Helmet>
                <title>Jobs - AirTeachr</title>
                <meta
                    name="description"
                    content="Discover Exciting Teaching Opportunities | airTeachr Jobs
            Explore a wide range of teaching jobs at airTeachr. Find your dream teaching position and make a difference in education. Join us today!"
                />
            </Helmet>
            {redirectToHome ? (
                <Redirect to="Home"></Redirect>
            ) : (
                <Grid
                    container
                    directon="row"
                    justifyContent="space-around"
                    alignItems="center"
                    sx={{
                        backgroundColor: 'rgba(0,0,0,0)',
                        backgroundImage:
                            'linear-gradient(130deg, #4632da 0%, #06d9fa 89%) ',

                        '&::before': {
                            content: "''",
                            position: 'absolute',
                            opacity: '0.15',
                            height: '100%',
                            width: '100%',
                            left: 0,
                            backgroundOverlay: '',
                            backgroundImage: `url(${
                                process.env.PUBLIC_URL + backgroundCircles
                            })`,
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        },
                        minHeight: '100vh',
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <StyledBox>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography
                                    variant="h1"
                                    sx={{
                                        color: '#ffffff',
                                    }}
                                >
                                    Job History
                                </Typography>
                                <Typography
                                    variant="h2"
                                    style={{
                                        m: '8px auto',
                                        color: '#ffffff',
                                        fontSize: '16px',
                                    }}
                                >
                                    A list of jobs posted by your school
                                </Typography>
                            </Box>
                            {newJob && (
                                <StyledPaper elevation={3}>
                                    <Box
                                        flexDirection="row"
                                        fullWidth
                                        sx={{ padding: '12px', width: '100%' }}
                                    >
                                        <Typography variant="h3">
                                            New Job Posting
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="Title"
                                            placeholder="Enter the title of the job"
                                            sx={{ margin: '12px 0px' }}
                                            onChange={e =>
                                                setState({
                                                    ...state,
                                                    'title': e.target.value,
                                                })
                                            }
                                            value={state.title}
                                        ></TextField>

                                        <TextField
                                            fullWidth
                                            label="Job Description"
                                            placeholder="Enter the description of the job"
                                            multiline
                                            minRows={5}
                                            onChange={e =>
                                                setState({
                                                    ...state,
                                                    'description':
                                                        e.target.value,
                                                })
                                            }
                                            value={state.description}
                                            sx={{
                                                margin: '12px 0px',
                                            }}
                                        ></TextField>
                                        <FormControl
                                            sx={{ margin: '12px 12px' }}
                                        >
                                            <InputLabel id="school-label-selection">
                                                Expiry Date
                                            </InputLabel>
                                            <Select
                                                labelId="job-expiry-label"
                                                id="job-expiry-label"
                                                value={state.expiryDate}
                                                label="Expiry Date"
                                                onChange={e => {
                                                    setState({
                                                        ...state,
                                                        'expiryDate':
                                                            e.target.value,
                                                    });
                                                }}
                                            >
                                                {dates.map((date, index) => {
                                                    return (
                                                        <MenuItem
                                                            value={date}
                                                            key={index}
                                                        >
                                                            {date}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                        <FormControl
                                            sx={{ margin: '12px 12px' }}
                                        >
                                            <InputLabel id="school-label-selection">
                                                Type Of Job
                                            </InputLabel>
                                            <Select
                                                labelId="job-type-label"
                                                id="job-type-label"
                                                value={state.typeOfJob}
                                                label="Type of Job"
                                                onChange={e => {
                                                    setState({
                                                        ...state,
                                                        'typeOfJob':
                                                            e.target.value,
                                                    });
                                                }}
                                            >
                                                {grades.map((grade, index) => {
                                                    return (
                                                        <MenuItem
                                                            value={grade.name}
                                                            key={index}
                                                        >
                                                            {grade.title}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                        <Box
                                            sx={{
                                                margin: '12px 0px',
                                                display: 'flex',
                                            }}
                                        >
                                            <BookingButton
                                                variant="contained"
                                                sx={{ margin: '0px 12px' }}
                                                onClick={submitJob}
                                            >
                                                Submit
                                            </BookingButton>
                                            <BookingButton
                                                variant="contained"
                                                sx={{ margin: '0px 12px' }}
                                                onClick={() => setNewJob(false)}
                                            >
                                                Cancel
                                            </BookingButton>
                                        </Box>
                                    </Box>
                                </StyledPaper>
                            )}
                            {loadingJobs ? (
                                <Loading />
                            ) : (
                                <>
                                    <Box
                                        sx={{
                                            //textAlign: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        {state.jobView?.schoolName ===
                                        undefined ? (
                                            <>
                                                {state.jobs.length > 0 ? (
                                                    state.jobs.map(job => (
                                                        <JobComponent
                                                            postDate={
                                                                job.postDate
                                                            }
                                                            schoolLogo={
                                                                job.schoolLogo
                                                            }
                                                            jobTitle={
                                                                job.jobTitle
                                                            }
                                                            schoolName={
                                                                job.schoolName
                                                            }
                                                            typeOfJob={
                                                                job.typeOfJob
                                                            }
                                                            location={
                                                                job.location
                                                            }
                                                            id={`${job.pk1}${job.sk1}`}
                                                            key={`${job.pk1}${job.sk1}`}
                                                            //viewJob={id => viewJob(id)}
                                                            viewJob={viewJob}
                                                        />
                                                    ))
                                                ) : (
                                                    <Typography
                                                        variant="h4"
                                                        style={{
                                                            color: '#ffffff',
                                                            marginTop: '36px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        No Jobs Found
                                                    </Typography>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <ViewJob
                                                    job={state.jobView}
                                                    close={closeJob}
                                                    updateJobStatus={
                                                        updateJobStatus
                                                    }
                                                />
                                            </>
                                        )}
                                    </Box>
                                </>
                            )}
                        </StyledBox>
                        {!newJob && (
                            <Fab
                                color="primary"
                                aria-label="add"
                                sx={{
                                    backgroundColor: '#4634da',
                                    display: 'block',
                                    zIndex: '10',
                                    position: 'fixed',
                                    left: '85%',
                                    top: '85%',
                                }}
                                onClick={() => setNewJob(true)}
                            >
                                <AddIcon />
                            </Fab>
                        )}
                    </Grid>
                </Grid>
            )}
        </>
    );
};

//This page is the location users are routed too when they log in
//It will detect if the user has a profile or not
//with no profile the user will be navigated to setUpProfile
//With a completed profile the user will be navigated to the Dashboard
export default SchoolJobs;
